import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconName } from '../icon/icon-data.generated';
import { IconColor, IconComponent } from '../icon/icon.component';

type ButtonVariant = 'text' | 'filled' | 'tonal' | 'outline';
type ButtonSize = 'xs' | 'sm' | 'md' | 'lg';

@Component({
  selector: 'app-icon-button',
  imports: [IconComponent],
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss'],
})
export class IconButtonComponent {
  @Input({ required: true }) icon!: IconName;
  @Input() ariaLabel?: string;
  @Input() variant: ButtonVariant = 'text';
  @Input() size: ButtonSize = 'md';
  @Input() color: IconColor = 'on-surface';
  @Input() disabled = false;
  @Output() clicked = new EventEmitter<MouseEvent>();

  onPointerDown(e: PointerEvent) {
    if (this.disabled) return;
    const target = e.currentTarget as HTMLElement;
    const rect = target.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    // set CSS vars for ripple center
    target.style.setProperty('--ripple-x', `${x}px`);
    target.style.setProperty('--ripple-y', `${y}px`);

    // retrigger animation
    target.classList.remove('ripple');
    // force reflow to restart the animation
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    target.offsetWidth;
    target.classList.add('ripple');
  }
}
